module.exports = __webpack_public_path__ + "img/bulb.a958a595.svg";